export const aciFavorite = {
    iconName: 'favorite',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 22 19' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M10.806 18.158L2.448 9.44a4.947 4.947 0 01-.926-5.708v0A4.945 4.945 0 019.44 2.448l1.365 1.365 1.364-1.365a4.945 4.945 0 017.92 1.285v0a4.947 4.947 0 01-.927 5.708l-8.357 8.717z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
